import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IPostLinkData } from '../../../types';
import { ReactComponent as BankTransferIntoIcon } from '../../../assets/icons/svg/large-icons/ic-large-bank.svg';
import Heading from '../../../generic-components/Heading';
import { PlaidActionWrapper } from '../components/PlaidActionWrapper';
import { useGenerateLinkToken } from '../../../hooks/query/useGenerateLinkToken';
import { useStore } from '../../../store';
import { trackMixPanel } from '../../../services/mixpanel.service';

const TEXTS = {
  TITLE: 'SEND_MONEY.INTRO.TITLE',
  SUBTITLE: 'SEND_MONEY.INTRO.SUBTITLE',
  CTA: 'SEND_MONEY.INTRO.CTA',
} as const;
const STYLES = {
  TITLE: 'text-bw08 font-metricRSemibold text-[25px] leading-10 text-center',
  SUBTITLE: 'text-bw07 font-metricR text-md leading-6 text-center mb-[30px]',
  CTA: 'w-[216px] h-[54px] bg-action03 hover:bg-action04 active:bg-action04 rounded-md text-bw00',
};

interface IProps {
  handlePlaidMetaData: (data: IPostLinkData) => void;
  isFetchingLinkedAccounts: boolean;
}

export const SendMoneyIntro = ({ handlePlaidMetaData, isFetchingLinkedAccounts }: IProps) => {
  const { t } = useTranslation();
  const { customerId } = useStore((state) => state.user);
  const [linkToken, setLinkToken] = useState<string>('');
  const { refetch: fetchLinkToken, isLoading, isRefetching } = useGenerateLinkToken(customerId);
  const handlePostLink = (data: IPostLinkData) => {
    setLinkToken('');
    handlePlaidMetaData(data);
  };
  const handleGenerateToken = () => {
    trackMixPanel('Act on Move Money Intro Screen', {
      Origin: 'Send Money',
      Flow: 'plaid transfer out',
      Action: 'Lets Start',
    });
    fetchLinkToken().then(({ data }) => {
      const {
        linkToken: { link_token: linkTokenRes },
      } = data;
      setLinkToken(linkTokenRes);
    });
  };
  useEffect(() => {
    trackMixPanel('View Move Money Intro Screen', { Origin: 'Send Money', Flow: 'plaid transfer out' });
  }, []);

  return (
    <div className='w-full flex flex-col justify-center items-center bg-bw00 h-full'>
      <div className='w-[370px] h-full flex justify-center items-center flex-col'>
        <div className='mb-[14px]'>
          <BankTransferIntoIcon />
        </div>
        <Heading title={t(TEXTS.TITLE)} className={STYLES.TITLE} testId='SendMoneyIntro-Title' />
        <p className={STYLES.SUBTITLE} data-testid='SendMoneyIntro-Subtitle'>
          {t(TEXTS.SUBTITLE)}
        </p>
        <PlaidActionWrapper
          shouldAutoOpenLink
          linkStyle={STYLES.CTA}
          linkTitle={t(TEXTS.CTA)}
          linkToken={linkToken}
          isLoading={isLoading || isFetchingLinkedAccounts || isRefetching}
          isFetchLinkToken={isLoading || isRefetching}
          callbackHandler={handleGenerateToken}
          handlePostLink={handlePostLink}
        />
      </div>
    </div>
  );
};
